module.exports = __webpack_public_path__ + "img/top-right-cloud.0d3794ae.svg";